import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=d5de9cdc&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
import style0 from "./Switch.vue?vue&type=style&index=0&id=d5de9cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5de9cdc",
  null
  
)

export default component.exports